import "./App.css";
import { theme } from "./theme";

//Router imports
import { Routes, Route, BrowserRouter } from "react-router-dom";

//UI Material components
import { ThemeProvider } from "@mui/material";

//Local components
import AppViewport from "./Components/app-viewport/AppViewport";
import ProtectedRoute from "./Components/ProtectedRoute";

//Pages
import NewOrder from "./Pages/NewOrder";
import Orders from "./Pages/Orders";
import Order from "./Pages/Order";
import Login from "./Pages/Login";
import RecoverEmail from "./Pages/RecoverEmail";
import Profile from "./Pages/Profile";
import Tasks from "./Pages/Tasks";
import Users from "./Pages/Users";
import Quote from "./Pages/Quote";
import Products from "./Pages/Products";
import Clients from "./Pages/Clients";
import Client from "./Pages/Client";
import Reports from "./Pages/Reports";
import ProducedItem from "./Pages/ProducedItem";
import Product from "./Pages/Product";
import Assembly from "./Pages/Assembly";
import Inventory from "./Pages/Inventory";
import Item from "./Pages/Item";
import ItemCategories from "./Pages/ItemCategories";
import Suppliers from "./Pages/Suppliers";
import Supplier from "./Pages/Supplier";
import Entry from "./Pages/Entry";
import Stockout from "./Pages/Stockout";
import ConnectivityDevices from "./Pages/ConnectivityDevices";
import ConnectivityDevice from "./Pages/ConnectivityDevice";
import CustomerService from "./Sections/CustomerService";
import Quotes from "./Pages/Quotes";
import NewQuote from "./Pages/NewQuote";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/sendRecoverEmail" element={<RecoverEmail />} />
          <Route
            path="/quote"
            element={
              <ProtectedRoute>
                <AppViewport content={<Quote />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/new-quote"
            element={
              <ProtectedRoute>
                <AppViewport content={<NewQuote />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer-service"
            element={
              <ProtectedRoute>
                <AppViewport content={<CustomerService />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <ProtectedRoute>
                <AppViewport content={<Clients />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client"
            element={
              <ProtectedRoute>
                <AppViewport content={<Client />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quotes"
            element={
              <ProtectedRoute>
                <AppViewport content={<Quotes />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/order"
            element={
              <ProtectedRoute>
                <AppViewport content={<Order />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/produced-item"
            element={
              <ProtectedRoute>
                <AppViewport content={<ProducedItem />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/product"
            element={
              <ProtectedRoute>
                <AppViewport content={<Product />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/item-categories"
            element={
              <ProtectedRoute>
                <AppViewport content={<ItemCategories />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/connectivity-devices"
            element={
              <ProtectedRoute>
                <AppViewport content={<ConnectivityDevices />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/connectivity-device"
            element={
              <ProtectedRoute>
                <AppViewport content={<ConnectivityDevice />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/item"
            element={
              <ProtectedRoute>
                <AppViewport content={<Item />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/entry"
            element={
              <ProtectedRoute>
                <AppViewport content={<Entry />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stockout"
            element={
              <ProtectedRoute>
                <AppViewport content={<Stockout />} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/assembly"
            element={
              <ProtectedRoute>
                <AppViewport content={<Assembly />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory"
            element={
              <ProtectedRoute>
                <AppViewport content={<Inventory />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/supplier"
            element={
              <ProtectedRoute>
                <AppViewport content={<Supplier />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/suppliers"
            element={
              <ProtectedRoute>
                <AppViewport content={<Suppliers />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <AppViewport content={<Products />} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/tasks"
            element={
              <ProtectedRoute>
                <AppViewport content={<Tasks />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/new-order"
            element={
              <ProtectedRoute>
                <AppViewport content={<NewOrder />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-account"
            element={
              <ProtectedRoute>
                <AppViewport content={<Profile />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <AppViewport content={<Users />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <AppViewport content={<Orders />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <AppViewport content={<Reports />} />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
